import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { fetchAllData, fetchData } from '../helpers/externapi';




export const downloadExcelData = async (pageType, totalCount, perPage, currentPage, fetchData, filterCriteria = [], setLoading, memberTypeId, eventid, status) => {
    setLoading(true);
    try {
        let allData = [];
        const totalPages = Math.ceil(totalCount / perPage);
        let filename;

        // for (let page = 1; page <= totalPages; page++) {
        const skip = (currentPage - 1) * perPage;
        const take = perPage;
        let data;

        switch (pageType) {
            case 'doctorslist':
                filename = 'Customers_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/all", { skip, take });
                }
                break;
            case 'customerrenewallist':
                filename = 'CustomersRenewals_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/RenewalList", { skip, take });
                }
                break;
            case 'customersrenewalcallscompleted':
                filename = 'CustomersRenewalsCallsCompleted_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/CustomersRenewalCallsCompleted", { skip, take });
                }
                break;
            case 'customersrenewalcallsnotcompleted':
                filename = 'CustomersRenewalsCallsNotCompleted_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/CustomersRenewalCallsNotCompleted", { skip, take });
                }
                break;
            case 'bankdetailslist':
                filename = 'AdvisorsBankdetailslist_data.xlsx';
                if (Object.keys(filterCriteria).length > 0) {
                    data = await fetchData("lambdaAPI/BankDetails/GetEmployeesWithBankDetails", filterCriteria);
                } else {
                    data = await fetchData("lambdaAPI/BankDetails/GetEmployeesWithBankDetails", {});
                }
                break;
            case 'distributorlist':
                filename = 'Distributor_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Member/FilterAdvisorDistributorListTodownloadExcel", { skip, take, filter: filterCriteria, memberTypeId: memberTypeId });
                } else {
                    data = await fetchData("Member/FetchAdvisorDistributorListTodownloadExcel", { skip, take, memberTypeId: memberTypeId });
                }
                break;
            case 'advisorlist':
                filename = 'Advisor_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Employee/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Employee/GetAdvisors", { skip, take, userRoleId: memberTypeId });
                }
                break;
            case 'employeeslist':
                filename = 'Employees_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Employee/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Employee/GetEmployees", { skip, take });
                }
                break;
            case 'leadslist':
                filename = 'Leads_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Lead/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Lead/all", { skip, take });
                }
                break;
            case 'hospitalslist':
                filename = 'Hospitals_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Hospital/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Hospital/all", { skip, take, IsActive: status === 'active' ? true : false });
                }
                break;
            case 'productslist':
                filename = 'Products_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Product/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Product/all", { skip, take });
                }
                break;
            case 'healthcamplist':
                filename = 'HealthCamp_data.xlsx';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Vitals/GetMemberVitalsDetailsDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Vitals/GetMemberVitalsDetails/all", { skip, take });
                }
                break;
            case 'healthcampcustomerlist':
                filename = 'HealthCampCustomers.xlsx';
                data = await fetchData("lambdaAPI/MemberEvents/MemberEventDetailsById", { skip, take, eventid });
                break;
                case 'SmartClinicList':
                filename = "SmartClinics_data.xlsx";
                data = await fetchData("lambdaAPI/SmartClinics/all", { skip, take, IsActive: status === 'active' ? true : false });
                break;
            default:
                throw new Error('Unknown page type');
        }

        allData = [...allData, ...data];
        // }

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        XLSX.writeFile(workbook, filename);

    } catch (error) {
        console.error("Error downloading Excel file:", error);
    } finally {
        setLoading(false);
    }
};

export const downloadCSVData = async (pageType, totalCount, perPage, currentPage, fetchData, filterCriteria = [], setLoading, memberTypeId, eventId, status) => {
    setLoading(true);
    try {
        let allData = [];
        const totalPages = Math.ceil(totalCount / perPage);
        let filename;

        // for (let page = 1; page <= totalPages; page++) {
        const skip = (currentPage - 1) * perPage;
        const take = perPage;
        let data;

        switch (pageType) {
            case 'doctorslist':
                filename = 'Customers_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/all", { skip, take });
                }
                break;
            case 'customerrenewallist':
                filename = 'CustomersRenewals_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/RenewalList", { skip, take });
                }
                break;
            case 'customersrenewalcallscompleted':
                filename = 'CustomersRenewalsCallsCompleted_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/CustomersRenewalCallsCompleted", { skip, take });
                }
                break;
            case 'customersrenewalcallsnotcompleted':
                filename = 'CustomersRenewalsCallsNotCompleted_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Customer/CustomersRenewalCallsNotCompleted", { skip, take });
                }
                break;
            case 'bankdetailslist':
                filename = 'AdvisorsBankdetailslist_data.csv';
                if (Object.keys(filterCriteria).length > 0) {
                    data = await fetchData("lambdaAPI/BankDetails/GetEmployeesWithBankDetails", filterCriteria);
                } else {
                    data = await fetchData("lambdaAPI/BankDetails/GetEmployeesWithBankDetails", {});
                }
                break;
            case 'distributorlist':
                filename = 'Distributor_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Member/GetMultipleDataByFilter", { skip, take, filter: filterCriteria, memberTypeId: memberTypeId });
                } else {
                    data = await fetchData("Member/all", { skip, take, memberTypeId: memberTypeId });
                }
                break;
            case 'advisorlist':
                filename = 'Advisor_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Employee/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Employee/GetAdvisors", { skip, take, userRoleId: memberTypeId });
                }
                break;
            case 'employeeslist':
                filename = 'Employees_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Employee/GetMultipleDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Employee/GetEmployees", { skip, take });
                }
                break;
            case 'leadslist':
                filename = 'Leads_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Lead/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Lead/all", { skip, take });
                }
                break;
            case 'hospitalslist':
                filename = 'Hospitals_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Hospital/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Hospital/all", { skip, take, IsActive: status === 'active' ? true : false });
                }
                break;
            case 'productslist':
                filename = 'Products_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("Product/Filter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("Product/all", { skip, take });
                }
                break;
            case 'healthcamplist':
                filename = 'HealthCamp_data.csv';
                if (filterCriteria.length > 0) {
                    data = await fetchData("lambdaAPI/Vitals/GetMemberVitalsDetailsDataByFilter", { skip, take, filter: filterCriteria });
                } else {
                    data = await fetchData("lambdaAPI/Vitals/GetMemberVitalsDetails/all", { skip, take });
                }
                break;
            case 'healthcampcustomerlist':
                filename = 'HealthCampCustomer.csv';
                data = await fetchData("lambdaAPI/MemberEvents/MemberEventDetailsById", { skip, take, eventId });
                break;
            case 'SmartClinicList':
                filename = "SmartClinics_data.csv";
                data = await fetchData("lambdaAPI/SmartClinics/all", { skip, take, IsActive: status === 'active' ? true : false });
                break;
            default:
                throw new Error('Unknown page type');
            // }

        }

        allData = [...allData, ...data];

        const csvData = convertToCSV(allData);
        downloadCSV(csvData, filename);

    } catch (error) {
        console.error("Error downloading CSV file:", error);
    } finally {
        setLoading(false);
    }
};

const convertToCSV = (jsonData) => {
    const csvRows = [];
    const headers = Object.keys(jsonData[0]);
    csvRows.push(headers.join(','));

    for (const data of jsonData) {
        const values = headers.map(header => {
            const escaped = ('' + data[header]).replace(/"/g, '\\"');
            return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
};

const downloadCSV = (csvData, filename) => {
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, filename);
};

export const constructCompleteAddress = (distributor) => {
    let addressParts = [];
    if (distributor.AddressLine1) addressParts.push(distributor.AddressLine1);
    if (distributor.AddressLine2) addressParts.push(distributor.AddressLine2);
    if (distributor.Village) addressParts.push(distributor.Village);
    if (distributor.Mandal) addressParts.push(distributor.Mandal);
    if (distributor.City) addressParts.push(distributor.City);
    if (distributor.DistrictName && distributor.DistrictId !== 0) addressParts.push(distributor.DistrictName);
    if (distributor.StateName && distributor.StateId !== 0) addressParts.push(distributor.StateName);
    if (distributor.Pincode && distributor.Pincode !== "0") addressParts.push(distributor.Pincode);

    let completeAddress = addressParts.join(', ');
    return completeAddress;
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate(); // Day of the month
    const month = date.toLocaleString('default', { month: 'short' }); // Three-letter month
    const year = date.getFullYear(); // Full year
    const hours = date.getHours() % 12 || 12; // Convert 24-hour format to 12-hour format
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Minutes with leading zero
    const amPm = date.getHours() >= 12 ? 'PM' : 'AM'; // Determine AM/PM

    return `${day} ${month} ${year} ${hours}:${minutes} ${amPm}`;
};


export const formatDate1 = (dateString) => {
    if (!dateString) return null; // Return null if date is missing

    const date = new Date(dateString);

    // Format day
    const day = String(date.getDate()).padStart(2, '0');

    // Format month
    const month = date.toLocaleString('en-GB', { month: 'short' });

    // Format year
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

export const fetchConfigValues = async () => {
    const config = await fetchData('ConfigValues/all', { skip: 0, take: 0 });

    if (config && config.length > 0) {
        const s3bucketPaymentURL = config.find(item => item.ConfigKey === 's3bucketPaymentURL')?.ConfigValue;
        const policiesDownloadURL = config.find(item => item.ConfigKey === 'policiesDownloadURL')?.ConfigValue;
        const productPoliciesURL = config.find(item => item.ConfigKey === 'productPoliciesURL')?.ConfigValue;
        const OHODistributorOTP = config.find(item => item.ConfigKey === 'OHODistributorOTP')?.ConfigValue;
        const OHOCustomerOTP = config.find(item => item.ConfigKey === 'OHOCustomerOTP')?.ConfigValue;
        const Brochures = config.find(item => item.ConfigKey === 'Brochures')?.ConfigValue;
        const phonePayMerchantId = config.find(item => item.ConfigKey === 'phonePayMerchantId')?.ConfigValue;
        const phonePaysaltKey = config.find(item => item.ConfigKey === 'phonePaysaltKey')?.ConfigValue;
        const phonePayEnvironment = config.find(item => item.ConfigKey === 'phonePayEnvironment')?.ConfigValue;
        const PaymentStaticQRCodeDisplay = config.find(item => item.ConfigKey === 'PaymentStaticQRCodeDisplay')?.ConfigValue;
        const UPIIdPayment = config.find(item => item.ConfigKey === 'UPIIdPayment')?.ConfigValue;
        const Cash = config.find(item => item.ConfigKey === 'Cash')?.ConfigValue;
        const CashfreePaymentLink = config.find(item => item.ConfigKey === 'CashfreePaymentLink')?.ConfigValue;
        const BizManageVersion = config.find(item => item.ConfigKey === 'BizManageVersion')?.ConfigValue;
        const S3IMAGES_URL = config.find(item => item.ConfigKey === 'S3_IMAGES_URL')?.ConfigValue;
        const userImagesBucketlink = config.find(item => item.ConfigKey === 'userImagesBucketlink')?.ConfigValue;
        const Notices = config.find(item => item.ConfigKey === 'Notices')?.ConfigValue;
        const NoticeTitle = config.find(item => item.ConfigKey === 'NoticeTitle')?.ConfigValue;
        const NoticeContent = config.find(item => item.ConfigKey === 'NoticeContent')?.ConfigValue;
        const SubNotice = config.find(item => item.ConfigKey === 'SubNotice')?.ConfigValue;
        const customerAadhar = config.find(item => item.ConfigKey === 'customerAadhar')?.ConfigValue;
        const advisorAadhar = config.find(item => item.ConfigKey === 'advisorAadhar')?.ConfigValue;
        const salesOffers = config.find(item => item.ConfigKey === 'salesOffers')?.ConfigValue;
        const salesOffersImage = config.find(item => item.ConfigKey === 'salesOffersImage')?.ConfigValue;
        const CardNumberEdit = config.find(item => item.ConfigKey === 'CardNumberEdit')?.ConfigValue;
        const NoCardSelection = config.find(item => item.ConfigKey === 'NoCardSelection')?.ConfigValue;
        const unassignCardsDisplay = config.find(item => item.ConfigKey === 'unassignCardsDisplay')?.ConfigValue;
        const OHOImageLogo = config.find(item => item.ConfigKey === 'OHOImageLogo')?.ConfigValue;
        const CardFront = config.find(item => item.ConfigKey === 'CardFront')?.ConfigValue;
        const CardBack = config.find(item => item.ConfigKey === 'CardBack')?.ConfigValue;
        const StaticQRCodeImage = config.find(item => item.ConfigKey === 'StaticQRCodeImage')?.ConfigValue;
        const OHOLogoBlueTheme = config.find(item => item.ConfigKey === 'OHOLogoBlueTheme')?.ConfigValue;
        const MinAge = config.find(item => item.ConfigKey === 'MinAge')?.ConfigValue;
        const MaxAge = config.find(item => item.ConfigKey === 'MaxAge')?.ConfigValue;
        const EnableOHOCards = config.find(item => item.ConfigKey === 'EnableOHOCards')?.ConfigValue;
        const OHOCardTextBox = config.find(item => item.ConfigKey === 'OHOCardTextBox')?.ConfigValue;
        const LogoWithoutName = config.find(item => item.ConfigKey === 'LogoWithoutName')?.ConfigValue;
        const LogoWithoutBG = config.find(item => item.ConfigKey === 'LogoWithoutBG')?.ConfigValue;
        const OHOConnectVersion = config.find(item => item.ConfigKey === 'OHOConnectVersion')?.ConfigValue;
        const YoutubeProductVideo = config.find(item => item.ConfigKey === 'YoutubeProductVideo')?.ConfigValue;
        const CustomerTestimonials = config.find(item => item.ConfigKey === 'CustomerTestimonials')?.ConfigValue;
        const EnableYoutubeProductVideo = config.find(item => item.ConfigKey === 'EnableYoutubeProductVideo')?.ConfigValue;
        const EnableCustomerTestimonials = config.find(item => item.ConfigKey === 'EnableCustomerTestimonials')?.ConfigValue;
        const userImageURL = config.find(item => item.ConfigKey === 'userImageURL')?.ConfigValue;
        const couponAmount = config.find(item => item.ConfigKey === 'couponAmount')?.ConfigValue;
        const reactNativeCode = config.find(item => item.ConfigKey === 'reactNativeCode')?.ConfigValue;
        const userProfileImage = config.find(item => item.ConfigKey === 'userProfileImage')?.ConfigValue;
        const PaymentSuccessTickImage = config.find(item => item.ConfigKey === 'PaymentSuccessTickImage')?.ConfigValue;
        const childrenMinimumAgeInDays = config.find(item => item.ConfigKey === 'childrenMinimumAgeInDays')?.ConfigValue;
        const OHOCareMobileNumber = config.find(item => item.ConfigKey === 'OHOCareMobileNumber')?.ConfigValue;
        const PremiumImage = config.find(item => item.ConfigKey === 'PremiumImage')?.ConfigValue;
        const PrivilegeImage = config.find(item => item.ConfigKey === 'PrivilegeImage')?.ConfigValue;
        const PriorityImage = config.find(item => item.ConfigKey === 'PriorityImage')?.ConfigValue;
        const couponImage = config.find(item => item.ConfigKey === 'couponImage')?.ConfigValue;
        const logoImageWhite = config.find(item => item.ConfigKey === 'logoImageWhite')?.ConfigValue;
        const ConsultationInvoiceBucketURL = config.find(item => item.ConfigKey === 'ConsultationInvoiceBucketURL')?.ConfigValue;
        const mapBoxPublicToken = config.find(item => item.ConfigKey === 'mapBoxPublicToken')?.ConfigValue;
        const HealthTip = config.find(item => item.ConfigKey === 'HealthTip')?.ConfigValue;
        const EnableKYCButton = config.find(item => item.ConfigKey === 'EnableKYCButton')?.ConfigValue;
        const ReactMapBoxToken = config.find(item => item.ConfigKey === 'REACT_APP_MAP_BOX')?.ConfigValue;
        const hospitalImagesURL = config.find(item => item.ConfigKey === 'hospitalImagesURL')?.ConfigValue;
        const mouBucketURL = config.find(item => item.ConfigKey === 'mouBucketURL')?.ConfigValue;
        const userDocumentsBucketURL = config.find(item => item.ConfigKey === 'userDocumentsBucketURL')?.ConfigValue;
        const GroupLogo = config.find(item => item.ConfigKey === 'GroupLogo')?.ConfigValue;
        const Image = config.find(item => item.ConfigKey === 'Image')?.ConfigValue;


        return {
            s3bucketPaymentURL: s3bucketPaymentURL || null,
            policiesDownloadURL: policiesDownloadURL || null,
            productPoliciesURL: productPoliciesURL || null,
            OHODistributorOTP: OHODistributorOTP || null,
            OHOCustomerOTP: OHOCustomerOTP || null,
            Brochures: Brochures || null,
            phonePayMerchantId: phonePayMerchantId || null,
            phonePaysaltKey: phonePaysaltKey || null,
            phonePayEnvironment: phonePayEnvironment || null,
            PaymentStaticQRCodeDisplay: PaymentStaticQRCodeDisplay || null,
            UPIIdPayment: UPIIdPayment || null,
            Cash: Cash || null,
            CashfreePaymentLink: CashfreePaymentLink || null,
            BizManageVersion: BizManageVersion || null,
            S3IMAGES_URL: S3IMAGES_URL || null,
            userImagesBucketlink: userImagesBucketlink || null,
            Notices: Notices || null,
            NoticeTitle: NoticeTitle || null,
            NoticeContent: NoticeContent || null,
            SubNotice: SubNotice || null,
            customerAadhar: customerAadhar || null,
            advisorAadhar: advisorAadhar || null,
            salesOffers: salesOffers || null,
            salesOffersImage: salesOffersImage || null,
            CardNumberEdit: CardNumberEdit || null,
            NoCardSelection: NoCardSelection || null,
            unassignCardsDisplay: unassignCardsDisplay || null,
            OHOImageLogo: OHOImageLogo || null,
            CardFront: CardFront || null,
            CardBack: CardBack || null,
            StaticQRCodeImage: StaticQRCodeImage || null,
            OHOLogoBlueTheme: OHOLogoBlueTheme || null,
            MinAge: MinAge || null,
            MaxAge: MaxAge || null,
            EnableOHOCards: EnableOHOCards || null,
            OHOCardTextBox: OHOCardTextBox || null,
            LogoWithoutName: LogoWithoutName || null,
            LogoWithoutBG: LogoWithoutBG || null,
            OHOConnectVersion: OHOConnectVersion || null,
            YoutubeProductVideo: YoutubeProductVideo || null,
            CustomerTestimonials: CustomerTestimonials || null,
            EnableYoutubeProductVideo: EnableYoutubeProductVideo || null,
            EnableCustomerTestimonials: EnableCustomerTestimonials || null,
            userImageURL: userImageURL || null,
            couponAmount: couponAmount || null,
            reactNativeCode: reactNativeCode || null,
            userProfileImage: userProfileImage || null,
            PaymentSuccessTickImage: PaymentSuccessTickImage || null,
            childrenMinimumAgeInDays: childrenMinimumAgeInDays || null,
            OHOCareMobileNumber: OHOCareMobileNumber || null,
            PremiumImage: PremiumImage || null,
            PrivilegeImage: PrivilegeImage || null,
            PriorityImage: PriorityImage || null,
            couponImage: couponImage || null,
            logoImageWhite: logoImageWhite || null,
            ConsultationInvoiceBucketURL: ConsultationInvoiceBucketURL || null,
            mapBoxPublicToken: mapBoxPublicToken || null,
            HealthTip: HealthTip || null,
            EnableKYCButton: EnableKYCButton || null,
            ReactMapBoxToken: ReactMapBoxToken || null,
            hospitalImagesURL: hospitalImagesURL || null,
            mouBucketURL: mouBucketURL || null,
            userDocumentsBucketURL: userDocumentsBucketURL || null,
            GroupLogo: GroupLogo || null,
            Image: Image || null,

        };
    } else {
        return {
            s3bucketPaymentURL: null,
            policiesDownloadURL: null,
            productPoliciesURL: null,
            OHODistributorOTP: null,
            OHOCustomerOTP: null,
            Brochures: null,
            phonePayMerchantId: null,
            phonePaysaltKey: null,
            phonePayEnvironment: null,
            PaymentStaticQRCodeDisplay: null,
            UPIIdPayment: null,
            Cash: null,
            CashfreePaymentLink: null,
            BizManageVersion: null,
            S3IMAGES_URL: null,
            userImagesBucketlink: null,
            Notices: null,
            NoticeTitle: null,
            SubNotice: null,
            customerAadhar: null,
            advisorAadhar: null,
            salesOffers: null,
            salesOffersImage: null,
            CardNumberEdit: null,
            NoCardSelection: null,
            unassignCardsDisplay: null,
            OHOImageLogo: null,
            CardFront: null,
            CardBack: null,
            StaticQRCodeImage: null,
            OHOLogoBlueTheme: null,
            MinAge: null,
            MaxAge: null,
            EnableOHOCards: null,
            OHOCardTextBox: null,
            LogoWithoutName: null,
            LogoWithoutBG: null,
            OHOConnectVersion: null,
            YoutubeProductVideo: null,
            CustomerTestimonials: null,
            EnableYoutubeProductVideo: null,
            EnableCustomerTestimonials: null,
            userImageURL: null,
            couponAmount: null,
            reactNativeCode: null,
            userProfileImage: null,
            PaymentSuccessTickImage: null,
            childrenMinimumAgeInDays: null,
            OHOCareMobileNumber: null,
            PremiumImage: null,
            PrivilegeImage: null,
            PriorityImage: null,
            couponImage: null,
            logoImageWhite: null,
            ConsultationInvoiceBucketURL: null,
            mapBoxPublicToken: null,
            HealthTip: null,
            EnableKYCButton: null,
            ReactMapBoxToken: null,
            hospitalImagesURL: null,
            mouBucketURL: null,
            userDocumentsBucketURL: null,
            GroupLogo: null,
            Image: null,
        };
    }
};

